import { useEffect } from "react";

const ensureLink = (rel) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  return el;
};

const ensureScriptJsonLd = (id = "jsonld") => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  return el;
};

const SITE = process.env.REACT_APP_SITE_URL || "";

const useSEO = ({
  title,
  description,
  keywords,
  path,
  noindex,
  jsonLd,
}) => {
  useEffect(() => {
    // ✅ Title
    if (title) document.title = title;

    // ✅ Description
    if (description) {
      let meta = document.querySelector('meta[name="description"]');

      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }

      meta.setAttribute("content", description);
    }

    // ✅ Keywords (optional)
    if (keywords) {
      let meta = document.querySelector('meta[name="keywords"]');

      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "keywords";
        document.head.appendChild(meta);
      }

      meta.setAttribute("content", keywords);
    }

    // ✅ Robots
    let robots = document.querySelector('meta[name="robots"]');

    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }

    robots.setAttribute(
      "content",
      noindex ? "noindex,nofollow" : "index,follow"
    );

    // ✅ Canonical (Google üçün çox vacib)
    if (SITE && path) {
      const canonical = ensureLink("canonical");
      canonical.setAttribute("href", `${SITE}${path}`);
    }

    // ✅ JSON-LD (Structured data)
    if (jsonLd) {
      const s = ensureScriptJsonLd("jsonld-main");
      s.text = JSON.stringify(jsonLd);
    }
  }, [title, description, keywords, path, noindex, jsonLd]);
};

export default useSEO;